import { Maybe } from '@crocodille/util';
import React from 'react';
import { useTranslation } from 'react-i18next';
import baguetteIcon from './bb-baguette.svg';
import coffeeIcon from './bb-coffee.svg';
import cn from 'classnames';
import Image from '@components/elements/image/image';

import styles from './loyalty-counter.module.scss';

const BAGUETTE_COUNTER_MAX = 5;
const COFFEE_COUNTER_MAX = 5;

export interface LoyaltyCounterProps {
  readonly size?: 'small' | 'large';
  readonly baguetteCounter: number;
  readonly coffeeCounter: number;
  readonly href?: Maybe<string>;
  readonly collapsible?: boolean;
}

const LoyaltyIcon: React.FC<{ readonly variant: 'baguette' | 'coffee' }> = ({
  variant,
}) => {
  return (
    <div
      className={cn(styles.counterIcon, {
        [styles.baguette]: variant === 'baguette',
        [styles.coffee]: variant === 'coffee',
      })}
    >
      <Image
        src={variant === 'baguette' ? baguetteIcon : coffeeIcon}
        role="presentation"
        alt=""
        layout="fill"
        objectFit="contain"
      />
    </div>
  );
};

const LoyaltyCounter: React.FC<LoyaltyCounterProps> = ({
  size = 'small',
  collapsible = false,
  baguetteCounter,
  coffeeCounter,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className={cn(styles.counters, {
          [styles.small]: size === 'small',
          [styles.collapsible]: collapsible,
        })}
      >
        <div className={styles.baguetteCounter}>
          <LoyaltyIcon variant="baguette" />
          <span className={styles.label}>{t('loyalty.baguette_counter')}</span>
          <span className={styles.counterCount}>
            &nbsp;
            {Math.min(baguetteCounter ?? 0, BAGUETTE_COUNTER_MAX - 1)}
            <span className={styles.counterTotal}>/{BAGUETTE_COUNTER_MAX}</span>
          </span>
        </div>
        <div className={styles.coffeeCounter}>
          <LoyaltyIcon variant="coffee" />
          <span className={styles.label}>{t('loyalty.coffee_counter')}</span>
          <span className={styles.counterCount}>
            &nbsp;
            {Math.min(coffeeCounter ?? 0, COFFEE_COUNTER_MAX - 1)}
            <span className={styles.counterTotal}>/{COFFEE_COUNTER_MAX}</span>
          </span>
        </div>
      </div>
    </>
  );
};

export default LoyaltyCounter;
